import * as XLSX from 'xlsx';

//jsonData, filename = 'data.xlsx'
function exportToExcel(jsonDataFile,filename) {
  // Создаем новую рабочую книгу
  const workbook = XLSX.utils.book_new();
  
  // Обрабатываем каждый лист
  Object.keys(jsonDataFile).forEach(sheetName => {
    const sheetData = jsonDataFile[sheetName];
    
    // Создаем рабочий лист из JSON данных
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    
    // Добавляем лист в книгу
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });
  
  // Сохраняем файл
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export default exportToExcel;

// Использование
// exportToExcel(jsonData, 'my_data.xlsx');